export default __webpack_public_path__ + "static/media/scan.97a4fce2.svg";